import { render, staticRenderFns } from "./ServiceEvents.vue?vue&type=template&id=2094c5de&scoped=true"
import script from "./ServiceEvents.vue?vue&type=script&lang=js"
export * from "./ServiceEvents.vue?vue&type=script&lang=js"
import style0 from "./ServiceEvents.vue?vue&type=style&index=0&id=2094c5de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2094c5de",
  null
  
)

export default component.exports